export const buildingLocations = {
  inland: 'inland',
  seashore: 'seashore',
  balticSea: 'balticSea',
  northSea: 'northSea',
}
